import api from '../services/api';
import { getFileNameFromContentDisposition } from './contentDisposition';

export const HEADER_IMPRESION_AVISO = 'x-impresion-aviso';

export interface FacturaVentaPdfResult {
  url: string;
  fileName: string | null;
  /** Aviso del API (ej. falló RDLC y se usó plantilla estándar). */
  avisoImpresion?: string | null;
}

/** Lee y decodifica el header X-Impresion-Aviso (URL-encoded UTF-8). */
export function leerAvisoImpresionDesdeHeaders(
  headers: Record<string, unknown> | undefined | null,
): string | null {
  if (!headers) return null;
  const raw =
    (headers[HEADER_IMPRESION_AVISO] as string | undefined) ??
    (headers['X-Impresion-Aviso'] as string | undefined);
  const texto = typeof raw === 'string' ? raw.trim() : '';
  if (!texto) return null;
  try {
    return decodeURIComponent(texto);
  } catch {
    return texto;
  }
}

export async function fetchFacturaVentaPdf(
  nroFormulario: number,
  idCompania?: string
): Promise<FacturaVentaPdfResult> {
  const params = idCompania?.trim()
    ? `?idCompania=${encodeURIComponent(idCompania.trim())}`
    : '';
  const response = await api.get(`/api/FacturasVenta/${nroFormulario}/pdf${params}`, {
    responseType: 'blob',
  });
  const headers = response.headers as Record<string, unknown>;
  const cd = headers?.['content-disposition'] as string | undefined;
  const fileName = getFileNameFromContentDisposition(cd) ?? null;
  const avisoImpresion = leerAvisoImpresionDesdeHeaders(headers);
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  return { url, fileName, avisoImpresion };
}
